import { blue } from '@mui/material/colors';
import React from 'react';
import { RawEditorOptions } from 'tinymce';

export const handlePasteWithPreprocessor =
    (
        preprocessor: (text: string) => string | null,
        onChange: (event: React.ClipboardEvent<HTMLInputElement>) => void
    ) =>
    (event: React.ClipboardEvent<HTMLInputElement>) => {
        event.preventDefault();
        const pastedText = event.clipboardData.getData('text');
        const processedText = preprocessor(pastedText);
        if (processedText === null) {
            event.stopPropagation();
            return;
        }
        const input = event.target as HTMLInputElement;
        const { selectionStart, selectionEnd, value } = input;
        const start = selectionStart || 0;
        const end = selectionEnd || 0;
        input.value = value.slice(0, start) + processedText + value.slice(end);
        const cursorPosition = start + processedText.length;
        input.setSelectionRange(cursorPosition, cursorPosition);
        onChange(event);
    };

export const handleRichTextPasteWithPreprocessor =
    (preprocessor: (text: string) => string): RawEditorOptions['paste_preprocess'] =>
    (editor, args) => {
        args.content = preprocessor(args.content);
    };

export const sanitizeUTF88591 = (text: string) => {
    // Sanitizer for ISO-8859-1 (https://en.wikipedia.org/wiki/ISO/IEC_8859-1)
    return (
        text
            // Quotes
            .replaceAll('“', '"')
            .replaceAll('”', '"')
            .replaceAll('‘', "'")
            .replaceAll('’', "'")
            // Dashes
            .replaceAll('–', '-')
            .replaceAll('‒', '--')
            .replaceAll('—', '--')
            // Punctuation
            .replaceAll('…', '...')
            // Spaces
            .replaceAll('\u00A0', '') // NBSP
            .replaceAll('\u202F', '') // NNBSP
            // Letters
            .replaceAll('œ', 'oe')
            .replaceAll('Œ', 'Oe')
            .replaceAll('Ÿ', 'ÿ')
            // Maths
            .replaceAll('×', '*')
            .replaceAll('÷', '/')
            // Other
            .replaceAll('€', 'euro')
            .replaceAll('•', '-')
    );
};

export const fieldHighlightStyle = {
    backgroundColor: blue[50],
    boxShadow: '0 0 3px rgba(25, 118, 210, 0.5)',
};
